import {
  CLEAR_PAYMENT_METHODS,
  GET_PAYMENT_METHOD_ERROR,
  GET_PAYMENT_METHOD_REQUEST,
  GET_PAYMENT_METHOD_SUCCESS,
} from '../Types';

const initialState = {
  isSuccess: false,
  isFetching: false,
  isSubmitting: false,
  isPaymentFormValid: false,
  methods: [],
  hasPaymentMethods: false,
  hasCardPayment: false,
  hasPaypalPayment: false,
  hasApplePayPayment: false,
  cardPayment: undefined,
  paypalPayment: undefined,
  hasGiftingPayment: false,
};

export const paymentMethods = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case GET_PAYMENT_METHOD_REQUEST:
      return { ...state, isFetching: true };
    case CLEAR_PAYMENT_METHODS:
      return { ...state, ...initialState };
    case GET_PAYMENT_METHOD_SUCCESS:
      return { ...state, ...payload, isSuccess: true, isFetching: false };
    case GET_PAYMENT_METHOD_ERROR:
      return { ...state, ...initialState, errorMessage: payload, isSuccess: true, isFetching: false };
    default:
      return state;
  }
};
